import React, { useState } from 'react';
import { styled } from 'styled-components';
import ShoppingAddons from '@components/shared/design/ShoppingAddons';
import PadsCompareModal from '@components/storefront/PadsCompareModal';
import PadsBoxSelection from './PadsBoxSelection';
import ProductBuyOptionHeading from './ProductBuyOptionHeading';
import { useShoppingContext } from './ProductShoppingContext';

const PadsPaymentBoxes: React.FC = () => {
  const { productHeaderData } = useShoppingContext();
  const { addonOptionsTitle } = productHeaderData;
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Wrapper>
      <PadsSelectionSection>
        <ProductBuyOptionHeading textKey="components.choose-box" onClick={() => setModalOpen(true)} />
        <PadsBoxSelection />
      </PadsSelectionSection>
      {addonOptionsTitle ? (
        <AddonOptionSection>
          <ProductBuyOptionHeading textKey={addonOptionsTitle} />
          <ShoppingAddons />
        </AddonOptionSection>
      ) : null}
      <PadsCompareModal modalOpen={modalOpen} closeModal={() => setModalOpen(false)} />
    </Wrapper>
  );
};

export default PadsPaymentBoxes;

const Wrapper = styled.div`
  width: 100%;
`;

const PadsSelectionSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
`;

const AddonOptionSection = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
`;
